<div
  id="nspBasket"
  role="dialog"
  data-cy="nspBasketModal"
  data-tms-event="popup-impression"
  data-tms-popup-zone="nsp"
  data-tms-popup-name="order confirmation"
  attr.data-tms-product="{{ jsonProduct }}"
>
  <div class="rs-modal-heading">
    <h2 class="rs-modal-heading-title" id="ac-modalConfirmation-label">
      {{ 'nsp.basket.title' | translate }}
    </h2>
  </div>

  <div class="rs-modal-content" >
    <ng-container *ngIf="!isActivationFlow">
      <h3 class="rs-tit4">{{ 'nsp.basket.changes' | translate }}</h3>
      <ul>
        <li *ngFor="let nspValue of nspAddedList">
          {{ 'nsp.basket.activate.mobile' | translate }}
          <mprd-access-number-formatter [accessNumber]="nspValue.accessNumber" [plc]="nspValue.plc">
          </mprd-access-number-formatter>
        </li>
        <li *ngFor="let nspValue of nspRemovedList">
          {{ 'nsp.basket.deactivate.mobile' | translate }}
          <mprd-access-number-formatter [accessNumber]="nspValue.accessNumber" [plc]="nspValue.plc">
          </mprd-access-number-formatter>
        </li>
      </ul>
      <p class="rs-txt-s3 rs-txt-details" *ngIf="nspRemovedList.length > 0">
        {{ 'nsp.basket.trial.disclaimer' | translate }}
      </p>
      <hr />
    </ng-container>
    <div *ngIf="!isAlwaysProtected">
      <h3 class="rs-tit4">{{ 'nsp.basket.price.monthlyCost' | translate }}</h3>
      <div class="rs-flex-row" *ngIf="hasInternetProduct " data-cy="nspBasketInternetPackProducts">
        <ng-container *ngFor="let accessNumber of getNspKeys(internetNspValues); let i = index">
          <div class="rs-flex-column">
            <div class="rs-padding-bottom1">
              <h4 class="rs-tit5 rs-txt-c1">{{ 'nsp.basket.product.internet' | translate }}</h4>
              <ng-container *ngIf="internetNspValues[accessNumber].trialOption">
                <p class="rs-txt-s3 rs-padding-bottom1">
                <span class="rs-txt-promo rs-font-pxB">
                  {{ 'nsp.basket.product.trialOption.freeTrial' | translate }}
                </span>
                  {{ 'nsp.basket.product.trialOption.until' | translate }}
                  {{
                    internetNspValues[accessNumber].trialOption?.deactivationDate
                      | date: 'dd MMMM yyyy'
                  }}
                </p>
              </ng-container>
            </div>
          </div>
          <div class="rs-flex-column rs-flex-shrink">
            <p>
              <strong>
                <mprd-price
                  [option]="nspInternetFakeOptionPrice"
                  [amountClass]="'rs-txt-s3'"
                  [showPriceForFree]="true"
                >
                </mprd-price>
              </strong>
            </p>
          </div>
        </ng-container>
      </div>

      <div class="rs-flex-row" *ngIf="hasMobileProduct && !isStandalone " data-cy="nspBasketMobilePackProducts">
        <div class="rs-flex-column">
          <div class="rs-padding-bottom1">
            <h4 class="rs-tit5 rs-txt-c1">{{ 'nsp.basket.product.mobile' | translate }}</h4>
            <ng-container *ngFor="let accessNumber of getNspKeys(mobileNspValues); let i = index">
              <p class="rs-txt-s3 rs-padding-bottom1" data-cy="nspBasketMobilePackProduct">
                <ng-container *ngIf="mobileNspValues[accessNumber].trialOption">
                <span class="rs-txt-promo rs-font-pxB">
                  {{ 'nsp.basket.product.trialOption.freeTrial' | translate }}
                </span>
                  {{ 'nsp.basket.product.trialOption.until' | translate }}
                  {{
                    mobileNspValues[accessNumber].trialOption?.deactivationDate | date: 'dd MMMM yyyy'
                  }}
                  <br />
                </ng-container>
                <span class="rs-txt-details">
                {{ 'nsp.basket.product.for' | translate }}
                  <mprd-access-number-formatter
                    [accessNumber]="accessNumber"
                    [plc]="mobileNspValues[accessNumber].plc"
                  >
                </mprd-access-number-formatter>
              </span>
                <br />
              </p>
            </ng-container>
          </div>
        </div>
        <div class="rs-flex-column rs-flex-shrink">
          <p>
            <strong>
              <mprd-price
                [option]="nspMobileFakeOptionPrice"
                [amountClass]="'rs-txt-s3'"
                [showPriceForFree]="true"
              >
              </mprd-price>
            </strong>
          </p>
        </div>
      </div>
      <ng-container *ngIf="hasMobileProduct && isStandalone">
        <div
          class="rs-flex-row"
          *ngFor="let accessNumber of getNspKeys(mobileNspValues); let i = index"
          data-cy="nspBasketMobileStandaloneProduct"
        >
          <div class="rs-flex-column">
            <div class="rs-padding-bottom1">
              <h4 class="rs-tit5 rs-txt-c1">{{ 'nsp.basket.product.mobile' | translate }}</h4>
              <ng-container *ngIf="mobileNspValues[accessNumber].trialOption">
              <span class="rs-txt-promo rs-font-pxB">
                {{ 'nsp.basket.product.trialOption.freeTrial' | translate }}
              </span>
                {{ 'nsp.basket.product.trialOption.until' | translate }}
                {{
                  mobileNspValues[accessNumber].trialOption?.deactivationDate | date: 'dd MMMM yyyy'
                }}
                <br />
              </ng-container>
              <p class="rs-txt-s3 rs-txt-details">
                {{ 'nsp.basket.product.for' | translate }}
                <mprd-access-number-formatter
                  [accessNumber]="accessNumber"
                  [plc]="mobileNspValues[accessNumber].plc"
                >
                </mprd-access-number-formatter>
                <br />
              </p>
            </div>
          </div>
          <div class="rs-flex-column rs-flex-shrink">
            <p>
              <strong>
                <mprd-price
                  [option]="nspMobileFakeOptionPrice"
                  [amountClass]="'rs-txt-s3'"
                  [showPriceForFree]="true"
                >
                </mprd-price>
              </strong>
            </p>
          </div>
        </div>
      </ng-container>
      <hr />
      <h3 class="rs-tit4">{{ 'nsp.basket.price.total' | translate }}</h3>
      <div class="rs-flex-row">
        <div class="rs-flex-column">
          <p class="rs-font-pxB">{{ 'nsp.basket.price.monthlyCost' | translate }}</p>
        </div>
        <div class="rs-flex-column rs-flex-shrink">
          <p class="text-right">
            <mprd-price [option]="fakeTotalOption" [showPriceForFree]="true"></mprd-price>
            <br /><span *ngIf="isActivationFlow && hasTrialOption" class="rs-txt-s3 rs-txt-details">{{
              'nsp.basket.price.trialPeriod' | translate
            }}</span>
          </p>
        </div>
      </div>
      <p class="rs-txt-s3 rs-txt-details">
        {{ 'nsp.basket.termsAndConditions' | translate }}
      </p>
    </div>

  </div>
  <div class="rs-modal-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-order-m2">
        <button
          class="rs-btn rs-btn-order rs-btn-nl-so"
          data-reveal-id="nspBasket"
          aria-haspopup="true"
          data-tms-button-name="'confirm'"
          data-tms-action-name="order confirm"
          [disabled]="isOrdering"
          (click)="confirm()"
        >
          {{ 'nsp.basket.button.confirm' | translate }}
        </button>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <button
          class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal"
          attr.data-tms-button-name="{{ 'nsp.basket.button.cancel' | translate }}"
          data-tms-action-name="close"
        >
          {{ 'nsp.basket.button.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
